import React from "react";
import { Outlet, Link } from "react-router-dom";
import ApertureMark from "./home/ApertureMark";
import { SITE } from "../content/site";
import "../styles/subpage.css";

// Minimal dark chrome for standalone routes (e.g. the privacy policy).
const Layout = () => {
  const year = new Date().getFullYear();

  return (
    // Subpage copy (the privacy policy) is English-only, whatever the toggle says.
    <div className="dp-subpage" lang="en">
      <header className="dp-subpage__header">
        <Link to="/" className="dp-subpage__brand" aria-label="Digital Philosophy — home">
          <ApertureMark className="dp-subpage__mark" strokeWidth={38} decorative />
          <span>Digital Philosophy</span>
        </Link>
        <Link to="/" className="dp-subpage__back">
          ← Home
        </Link>
      </header>
      <main className="dp-subpage__main">
        <Outlet />
      </main>
      <footer className="dp-subpage__footer">
        <span>
          © {year} {SITE.legalName}
        </span>
        <span>{SITE.address}</span>
      </footer>
    </div>
  );
};

export default Layout;
